exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-override---2Hu5_ > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 260px !important;\n  padding: 30px 40px 5px; }\n\n.modal-override---2Hu5_ [class*=\"ButtonContainer\"] {\n  margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"modal-override": "modal-override---2Hu5_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/footer/footer-popup/footer-popup.scss
// module id = qmGw
// module chunks = 1